import { Observable } from 'rxjs';

export const CUSTOMER_REPOSITORY = 'CustomersRepository';

export interface CustomersRepository {
  getItems(): Observable<any>;

  getItemId(typeIdentify: string, identify: string): Observable<any>;

  getTypeIdentify(): Observable<any>;
}
